import { render, staticRenderFns } from "./profile-album-header.vue?vue&type=template&id=67a538c8&"
import script from "./profile-album-header.vue?vue&type=script&lang=js&"
export * from "./profile-album-header.vue?vue&type=script&lang=js&"
import style0 from "./profile-album-header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a538c8')) {
      api.createRecord('67a538c8', component.options)
    } else {
      api.reload('67a538c8', component.options)
    }
    module.hot.accept("./profile-album-header.vue?vue&type=template&id=67a538c8&", function () {
      api.rerender('67a538c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/account/profile/album/profile-album-header.vue"
export default component.exports